import React from 'react';
import { find as _find } from 'lodash';

export default class AbstractTimelineEvent extends React.Component {
  getParam = (name, defaultValue = null) => {
    const { event } = this.props;

    const param = _find(event.params || event.getParams(), ['name', name]);
    if (param) {
      return param.getValue ? param.getValue() : param.value;
    }

    return defaultValue;
  };

  getDynParam = (name, defaultValue = null) => {
    const { event } = this.props;

    const param = _find(event.dyn_params || (event.getDynParams && event.getDynParams()), ['name', name]);
    if (param) {
      return param.getValue ? param.getValue() : param.value;
    }

    return defaultValue;
  };
}
